<ae2-seo [title]="'Studio Kore: exercício funcional para todos os níveis'"
    [metaDescription]="'Studio Kore é o exercício funcional reinventado. Aula intensa de cardio, força e resistência que tonifica, acelera a queima calórica e desperta seu potencial.'"
    [Keyword]="'Studio Kore; Exercício Funcional'">
</ae2-seo>
<ae2-carousel-container carouselCode="home-kore" [config]="carouselConfig"></ae2-carousel-container>